<template>
  <div class="business-income-list-container">
    <el-tabs v-model="scopeType" :stretch="false" @tab-click="handleChange">
      <el-tab-pane :label="tab.label" :name="tab.name" v-for="(tab) in scopeTabs" :key="tab.name"></el-tab-pane>
    </el-tabs>
    <div class="head flex-align-center">
      <div style="display: flex;align-items: center;">
        <el-form :model="query" size="mini" inline>
          <el-form-item>
            <el-date-picker
                style="width: 220px"
                v-model="query.date_range"
                type="monthrange"
                align="right"
                unlink-panels
                format="yyyy年MM月"
                value-format="yyyy-MM"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="query.exec_timestamp"
                            style="width: 130px" type="month"
                            format="yyyy年MM月"
                            value-format="yyyy-MM"
                            placeholder="搜索月份"
            />
          </el-form-item>
          <el-form-item>
            <select-artist :value.sync="query.artist_id" style="width: 100%"/>
          </el-form-item>
          <el-form-item>
            <el-input style="width: 120px" v-model="query.agent_name" placeholder="经纪人"
                      v-if="this.query.scope_type!=='mine'" clearable/>
          </el-form-item>
          <el-form-item label="">
            <UserSearch @handleSelect="changeUserAid" placeholder="转交人"
                        v-if="this.query.scope_type!=='toMe'"></UserSearch>
          </el-form-item>
          <el-form-item>
            <el-input v-model="query.order_no" placeholder="订单编号" clearable/>
          </el-form-item>
          <el-form-item>
            <select-brand :value.sync="query.brand_id"/>
          </el-form-item>
          <el-form-item>
            <company-select :company-id.sync="query.company_id"/>
          </el-form-item>
          <el-form-item>
            <el-select style="width: 100px" v-model="query.is_confirm" placeholder="确认状态" clearable
                       @change="handleSearch" size="mini">
              <el-option label="已确认" value="Y"></el-option>
              <el-option label="未确认" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" icon="el-icon-search" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <export-by-page v-if="query.scope_type==='all'" :tableName="tableName" module="BUSINESS_INCOME" type="warning" :search="query"/>
            <export-by-page v-if="query.scope_type!=='all'" :tableName="tableName" module="BUSINESS_INCOME_AGENT" type="warning" :search="query"/>
          </el-form-item>
          <div>
            <el-form-item>
              <el-button v-permission="'business_income_confirm__btn'" type="success" size="mini"
                         :disabled="pageSelectedList.length === 0" @click="handleConfirm('品宣')">
                确认品宣订单
              </el-button>
              <el-button v-permission="'business_income_confirm__btn'" type="success" size="mini"
                         :disabled="pageSelectedList.length === 0" @click="handleConfirm('直播')">
                确认直播订单
              </el-button>
            </el-form-item>
            <el-form-item v-if="query.scope_type!=='toMe'">
              <el-button v-permission="'business_income_confirm__btn'" type="primary" round plain size="mini"
                         :disabled="pageSelectedList.length === 0" @click="handleToAssistantConfirm">
                转交助理
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <!--    广告订单列表表格  -->
    <div ref="tblDiv" v-loading="loading"
         element-loading-text="加载中……"
         element-loading-spinner="el-icon-loading">
      <BusinessIncomeTable ref="refTableIsBiOrder"
                           :query-params.sync="query"
                           :need-operate="false"
                           @refreshOrderList="getOrdersList"
                           @handleSelectionChange="handleSelectionChange"
                           @goDetail="goDetail" :selected-data.sync="pageSelectedList"
                           @clearData="clearData">
      </BusinessIncomeTable>
    </div>

    <!-- 确认弹框 -->
    <el-dialog
        :title="dialogTitle"
        :visible.sync="confirmDialogVisible"
        width="800px"
        :close-on-click-modal="false">
      <div>
        <el-table :data="pageSelectedList" border size="mini">
          <el-table-column label="红人名称" prop="artist_nickname" width="130"/>
          <el-table-column label="经纪人" prop="agent_name" width="90"/>
          <el-table-column label="订单编号" align="right" width="120">
            <template v-slot="{ row }">
              {{ row.order_no }}
              <!--              <to-order-detail by-field="order_no" :order="{ order_no: row.order_no, order_id: row.id }"/>-->
            </template>
          </el-table-column>
          <el-table-column label="可分配收入" align="right" width="120">
            <template v-slot="{row}">
              <!--              广告收入 - 返点金额-->
              ￥{{ (Number(row.adv_revenue) - Number(row.rebates_amount) || 0) | numberFormat(2) }}
            </template>
          </el-table-column>
          <el-table-column label="红人分成" align="right" width="120">
            <template v-slot="{row}">
              ￥{{ (row.artist_income || 0) | numberFormat(2) }}
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px; text-align: right; font-weight: bold;">
          总计广告收入：￥{{ moneyFormat(confirmTotalAmount) }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div style="display: flex;  flex-direction: row;  justify-content: center;  gap: 10px;">
          <UserSearch class="el-input-c-m" @handleSelect="changeAgent" placeholder="转交人（姓名模糊搜索）" v-if="showAssistant" style="width: 300px"/>
          <div>
            <!--            <el-button @click="confirmDialogVisible = false">取消</el-button>-->
            <el-button type="primary" round @click="submitToAssistant" v-if="showAssistant">确定转交</el-button>
            <el-button type="primary" @click="submitConfirm" v-else>确定确认</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
// 全局方法
import SelectArtist from "@/components/Selects/artist.vue";
import SelectBrand from "@/components/Selects/brand.vue";
import {businessIncomeList, confirmIncome, setAssistant} from "@/api/incomeSummary";
import BusinessIncomeTable from "./table/BusinessIncomeTable.vue";
import CompanySelect from "@/views/adOrder/components/companySelect.vue";
import ExportByPage from "@/components/export/ByPage/index.vue";
import moment from "moment";
import {isArray} from "@/utils/util";

export default {
  name: "incomeBusiness",
  components: {
    ExportByPage,
    CompanySelect,
    BusinessIncomeTable,
    SelectArtist,
    SelectBrand,
  },
  data() {
    return {
      scopeType: 'toMe',//数据范围
      scopeTabs: [
        {'label': '全部', 'name': 'all', 'auth': 'business_income_scope_all'},
        {'label': '我负责的', 'name': 'mine', 'auth': 'business_income_scope_agent'},
        {'label': '转交我的', 'name': 'toMe', 'auth': 'business_income_scope_assistant'},
      ],
      tableName: 'business_income_table',
      loading: false,
      expandKeys: [],
      pageSelectedList: [],//预览数据列表
      query: {
        scope_type: 'mine',
        exec_timestamp: null,
        artist_id: null,
        agent_name: null,
        user_aid: null,
        order_no: null,
        brand_id: null,
        company_id: null,
        date_range: [],
        ack_status: null,
        is_notify: 'Y'
      },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      isColSet: false,
      confirmDialogVisible: false,
      showAssistant: false,
      dialogTitle: '确认收入信息',
      confirmType: '',
      selectedOrders: [],
      businessIncomeList: businessIncomeList,
    };
  },
  computed: {
    confirmTotalAmount() {
      let total = 0;
      if(this.pageSelectedList && isArray(this.pageSelectedList)){
        this.pageSelectedList.forEach((row) => {
          // 使用广告收入字段计算，而不是分成收入
          total += (row.adv_revenue || 0) / 1;
        });
      }

      return total;
    }
  },
  mounted() {
    this.query.exec_timestamp = moment().subtract(1, 'month').format('YYYY-MM');
    this.calcTabs()
  },
  methods: {
    handleQuery() {
      this.query.scope_type = this.scopeType
      if (this.$refs['refTableIsBiOrder'])
        this.$refs['refTableIsBiOrder'].handleQuery(this.query)
    },
    // eslint-disable-next-line no-unused-vars
    handleChange(tab, event) {
      this.query.scope_type = this.scopeType
      // 清空已选
      this.clearData()
      //筛选数据
      this.handleQuery()
    },
    calcTabs() {
      const permissions = localStorage.getItem('userAuth') ? JSON.parse(localStorage.getItem('userAuth')).value : {}
      this.scopeTabs = []
      if (permissions['business_income_scope_all']) {
        this.scopeTabs.push({'label': '全部', 'name': 'all', 'auth': 'business_income_scope_all'})
      }

      if (permissions['business_income_scope_agent']) {
        this.scopeTabs.push({'label': '我负责的', 'name': 'mine', 'auth': 'business_income_scope_agent'})
      }

      if (permissions['business_income_scope_assistant']) {
        this.scopeTabs.push({'label': '转交我的', 'name': 'toMe', 'auth': 'business_income_scope_assistant'})
      }

      //默认显示tab
      const len = this.scopeTabs.length
      if (len > 0 && this.scopeTabs[0]){
        this.scopeType = this.scopeTabs[0]['name']
        this.handleQuery()
      }

    },
    changeUserAid(item) {
      this.query.user_aid = item.id || 0
    },
    handleSearch: function () {
      if (this.$refs['refTableIsBiOrder'])
        this.$refs['refTableIsBiOrder'].handleQuery(this.query)
    },

    handleSelectionChange(val) {
      this.selectedOrders = val
      this.addPreview()
    },
    //预览数据添加
    addPreview() {
      if (this.selectedOrders && isArray(this.selectedOrders)&&this.selectedOrders.length > 0) {
        this.selectedOrders.forEach((row) => {
          const currentIdIndex = this.pageSelectedList.findIndex(value => value.id === row.id)
          if (currentIdIndex === -1) {
            this.pageSelectedList.push({...row})
          }
        })
      }
    },
    //加载订单列表
    getOrdersList() {
      if (this.$refs['refTableIsBiOrder'])
        this.$refs['refTableIsBiOrder'].initList()
    },
    //预览数据-清空
    clearData() {
      this.pageSelectedList = []
      if (this.$refs['refTableIsBiOrder'])
        this.$refs['refTableIsBiOrder'].handleClearSelection()
    },
    goDetail(row) {
      //详情页面，修改页面
      this.editPage(row.id)
    },
    editPage(id) {
      const {href} = this.$router.resolve({
        name: 'editAdOrder',
        params: {id: id},
      });
      window.open(href, "_blank");
    },
    // 确认按钮点击事件
    handleConfirm(confirm_type) {
      this.confirmType = confirm_type
      this.confirmDialogVisible = true;
      this.dialogTitle = `确认${this.confirmType}订单`
      this.showAssistant = false;
    },
    // 提交确认
    async submitConfirm() {
      try {
        const ids = this.pageSelectedList.map(item => item.id);
        const params = {
          ids: ids,
          type: 'business',
          confirm_type: this.confirmType,
        };
        const {success} = await confirmIncome(params);

        if (success) {
          this.msgSuccess('确认成功');
          this.confirmDialogVisible = false;
          // 刷新数据
          this.getOrdersList();
          // 清空已选
          this.clearData()
        } else {
          this.$message.error('确认失败，请重试');
        }
      } catch (error) {
        this.$message.error('确认失败，请重试');
      }
    },
    moneyFormat(val) {
      return this.$utils.numberFormat(val, 2);
    },
    //确认订单
    handleToAssistantConfirm() {
      this.confirmDialogVisible = true;
      this.dialogTitle = '转交经纪人助理'
      this.showAssistant = true;
    },
    changeAgent(val) {
      if (val.id) {
        this.user_aid = val.id
      } else {
        this.user_aid = null
      }
    },
    //转交给助理
    async submitToAssistant() {
      try {
        const ids = this.pageSelectedList.map(item => item.id);
        if (ids.length === 0) {
          this.$notify.warning('至少选择一个订单')
          return false;
        }
        if (!this.user_aid) {
          this.$notify.warning('请选择转交人')
          return false;
        }
        const {success} = await setAssistant('business', ids, this.user_aid);

        if (success) {
          this.msgSuccess('确认成功');
          this.confirmDialogVisible = false;
          // 刷新数据
          this.getOrdersList();
        } else {
          this.$message.error('确认失败，请重试');
        }
      } catch (error) {
        this.$message.error('确认失败，请重试');
      }
    },
  }
};
</script>


<style lang="scss">
.business-income-list-container {
  padding: 5px 10px;
  height: calc(100vh - 166px);

  .el-table .red-row {
    background: #ffeeee;
  }

  .el-table thead tr, .el-table thead th {
    background: white !important;
    color: #3c3c3c !important;
    font-weight: 600;
  }

  .flag-error {
    display: inline-block;
    width: auto;
    line-height: 17px;
    padding: 0 10px;
    border-radius: 9px;
    //border: 1px solid #ab0707;
    color: #FFFFFF;
    background-color: #ab0707;
    font-size: 12px;
    cursor: pointer;
  }

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;

    .el-select {
      //width: 250px;
      margin-right: 12px;
    }
  }

  .ape-table-container {
    height: calc(100% - 206px) !important;
  }

  .tip-time {
    color: #8a8e99;
    font-size: 12px;
    margin-right: 10px;
  }

  .tip-help {
    margin-top: 40px;
    margin-bottom: 10px;
    padding: 8px 24px;
    overflow-y: auto;
    background-color: #FFF9FBFC;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    line-height: 22px;
    color: #666;
    border-radius: 9px;
    position: relative;
    box-sizing: border-box;
    height: 110px;
  }

  .tag {
    border-radius: 3px;
    background-color: #ffeef3;
    color: #fe346e;
    font-size: 12px;
    padding: 0 8px;
    height: 20px;
    line-height: 20px;
  }

  .el-table .cell {
    height: auto !important;
  }

  .el-table th.el-table__cell > .cell {
    min-height: 34px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-table .sort-caret.ascending {
    top: 7px !important;
  }

  .el-table .sort-caret.descending {
    bottom: 5px !important;
  }

  .over-hidden {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .live-sm:hover {
    .live-sm__mark {
      opacity: .7 !important;
    }
  }

  .live-sm {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    position: relative;
    cursor: pointer;

    &__mark {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #111;
      opacity: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 4px;

      span {
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }

  .tableCon {
    height: calc(100% - 50px);
    overflow: scroll;
  }
}
</style>
